export default __webpack_public_path__ + "static/media/FRONT-END.07d2b0ab.svg";